import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-custom-tooltip',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './custom-tooltip.component.html',
    styleUrl: './custom-tooltip.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTooltipComponent implements OnInit {
    @Input() content: string | { [key: string]: number | string | null } = '';

    ngOnInit(): void {
        this.createTooltip();
    }

    createTooltip(): void {
        if (this.content && typeof this.content !== 'string') {
            this.content = JSON.stringify(this.content, null, 2)
                .replace(/^/gm, '  ') // Добавляем отступ в начале каждой строки
                .replace(/\n\s*}/g, '\n}') // Убираем отступ перед закрывающей фигурной скобкой
                .replace(/\n\s*]/g, '\n]'); // Убираем отступ перед закрывающей квадратной скобкой
        }
    }
}
